<template>	
	<div class="auth-form">
		<div class="text-center logo"><img :src="stylePathToLogo || '/static/img/logo/logo.png'" /></div>

		<h4 class="text-center">{{ 'login/title' | ftc }}</h4>

		<fieldset :disabled="form_Loading">
		<div class="w5-field">
			<span class="al w5-z-index-1" :class="{ animated: animatedEmail, focused: isFocusedEmail, unfocused: !isFocusedEmail }">{{ 'main/email' | ftc }}<span class="required-field"> *</span></span>
			<input name="email" type="text" id="email" aria-describedby="emailHelp" :placeholder="`main/email *` | ftc" :class=" { haserror: form_ErrorMessage }"
			:disabled="isInputDisabled" :readonly="isInputDisabled"
			ref="email" v-model="email" @focus="OnFocus" @blur="OnBlur" @keyup="OnKeyUp">
		</div>

		<div class="w5-field">
			<span class="al w5-z-index-1" :class="{ animated: animatedPassword, focused: isFocusedPassword, unfocused: !isFocusedPassword }">{{ 'main/password' | ftc }}<span class="required-field"> *</span></span>
			<input name="password" type="password" id="password" aria-describedby="passwordHelp" :placeholder="`main/password *` | ftc" :class=" { haserror: form_ErrorMessage }"
			:disabled="isInputDisabled" :readonly="isInputDisabled"
			ref="password" v-model="password" @focus="OnFocus" @blur="OnBlur" @keyup="OnKeyUp">
			<div class="alert alert-danger w5-error-block" role="alert" v-show="form_ErrorMessage !== false" style="margin-bottom: 0" v-withSafeTags="localeFtc(form_ErrorMessage)"></div>
		</div>

		<div class="w5-field w5-new-checkbox-wrapper" v-show="!is_admin">
			<input id="wcp_login_form_remember" type="checkbox" class="w5-checkbox-field"
			v-model="rememberMe" :true-value="1" :false-value="0">
			<label for="wcp_login_form_remember">{{ 'login/remember_me' | ftc }}</label>
		</div>

		<div class="w5-field text-center">
			<img src="/static/img/loading32.gif" v-show="form_Loading" />
			<button class="btn btn-submit btn-primary btn-block" type="button"
			ref="button" @click="login" v-show="!form_Loading">{{ 'main/enter' | ftc }}</button>
		</div>
		</fieldset>

		<div class="w5-field" v-show="!form_Loading">
			<router-link to="/register" class="pull-left">{{ 'page/user_register' | ftc }}</router-link>
			<router-link to="/forget" class="pull-right">{{ 'login/forgot' | ftc }}</router-link>
		</div>

		<!-- диалог 2FA -->
		<transition name="modal">
			<div v-show="show2FADialogModal" @click="hide2FADialogModal" class="modal-mask">
				<div class="modal-wrapper">
					<div class="modal-container narrow" @click.stop>
						<!-- заголовок -->
						<div class="modal-header">
							<span class="font-weight-500">{{ 'twofa/check_title' | ftc }}</span>
							<button type="button" class="close" @click="hide2FADialogModal">&times;</button>
						</div>
						<!-- тело диалога -->
						<div v-if="fields2FA && fields2FA.fields" class="modal-body">
							<div v-for="(row, index) in fields2FA.fields" v-if="row" :key="index" :class="{ 'w5-form-row': isVisibleField(row) }">
								<Field v-for="field in row"
									:key="field._field_name"
									:ref="field._field_name"
									:isVisibleRow="isVisibleField(row)"
									:fieldInModal="true"
									:removeRightPadding="true"
									crud="twofa"
									action="check"
									:Field="field"
									v-model="field.value"
									@focus="onFocus2FA(field)"
									@enterKeyDown="submit2FAForm" />
							</div>
						</div>
						<!-- подвал -->
						<div class="modal-footer">
							<span class="btn btn-submit" @click="submit2FAForm">{{ 'twofa/check' | ftc }}</span>
						</div>
					</div>
				</div>
			</div>
		</transition>

	</div>	
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import Vue from 'vue'
import Helper from '@/helper/helper'
import Field from '@/components/elements/formfield'
import { EventBus } from '@/bus.js'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'loginForm',
	//=========================================================================
	// свойства компонента
	//=========================================================================
	data() {
		return {
			email: '',
			password: '',
			rememberMe: '1',

			// по умолчанию выключена, обычно включается при первом фокусе на поле
			animatedEmail: false,
			// в фокусе поле или нет
			isFocusedEmail: false,
			// по умолчанию выключена, обычно включается при первом фокусе на поле
			animatedPassword: false,
			// в фокусе поле или нет
			isFocusedPassword: false,

			// блокировка полей
			isInputDisabled: false,

			// 2FA
			show2FADialogModal: false,
			fields2FA: null
		}
	},
	//=========================================================================
	// вычисляемые свойства компонента
	//=========================================================================
	computed: {
		is_admin() {
			return !Helper.validateEmail(this.email)
		}
	},
	//=========================================================================
	// событие: компонент создан
	//=========================================================================
	created() {
		// если пользователь авторизован - редирект на главную страницу
		if (this.$store.state.is_auth)
		{
			// делаем редирект
			return this.$router.push('/')
		}
	},
	//=========================================================================
	// событие: компонент примонтирован в DOM
	//=========================================================================
	mounted() {
		// проверка - заполнил ли браузер поле "email"?
		setTimeout(() => {
			let _email = document.getElementById('email')
			if (_email && _email.value && _email.value.length)
			{
				// да - поле заполнено, ставим фокус на пароле,
				// для того что бы отработала анимация хотя бы на поле email
				//
				// приложение увидит какой пароль проставил браузер ТОЛЬКО
				// после какого то действия человека, поэтому анимация на поле
				// с паролем пока невозможна, но мы постараемся
				document.getElementById('password').focus()
			}
		}, 400)
	},
	//=========================================================================
	// функции компонента
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		// событие: фокус на поле формы
		//---------------------------------------------------------------------
		OnFocus(e) {
			if (e && e.target)
			{
				if (e.target.getAttribute('name') === 'email')
				{
					// при первом фокусе - включаем анимацию
					this.animatedEmail = true
					// добавляем класс "focused"
					this.isFocusedEmail = true
				}
				else if (e.target.getAttribute('name') === 'password')
				{
					// при первом фокусе - включаем анимацию
					this.animatedPassword = true
					// добавляем класс "focused"
					this.isFocusedPassword = true
				}
			}

			this.form_ErrorMessage = false
			this.removeErrorBorder_OnFocus(e)
		},
		//---------------------------------------------------------------------
		// событие: потеря фокуса полем формы
		//---------------------------------------------------------------------
		OnBlur(e) {
			if (e && e.target)
			{
				if (e.target.getAttribute('name') === 'email')
				{
					// убираем класс "focused" только если значение пустое
					if (e.target.value === null || e.target.value === undefined || e.target.value === '')
						this.isFocusedEmail = false
				}
				else if (e.target.getAttribute('name') === 'password')
				{
					// убираем класс "focused" только если значение пустое
					if (e.target.value === null || e.target.value === undefined || e.target.value === '')
						this.isFocusedPassword = false
				}
			}

			this.form_ErrorMessage = false
			this.removeErrorBorder_OnFocus(e)
		},
		//---------------------------------------------------------------------
		// событие: клавишы по полю
		//---------------------------------------------------------------------
		OnKeyUp(e) {
			this.form_ErrorMessage = false
			this.removeErrorBorder_OnFocus(e)
			this.enterOnInput(e)
		},
		//---------------------------------------------------------------------
		// реакция на отрицательный результат запроса
		//---------------------------------------------------------------------
		failRequest() {
			// ставим в поля красные рамки
			if (this.$refs['email'] && this.$refs['email'].parentNode) this.addClass(this.$refs['email'].parentNode, 'has-error')
			if (this.$refs['password'] && this.$refs['password'].parentNode) this.addClass(this.$refs['password'].parentNode, 'has-error')
			// ставим текст сообщения
			this.form_ErrorMessage = this.localeFtc('login/incorrect')
			// аутентификации может и не быть, но подстрахуемся
			this.$store.commit('dropAuth')
		},
		//---------------------------------------------------------------------
		// запрос на аутентификацию
		//---------------------------------------------------------------------
		login() {
			// обнуляем ошибку
			this.form_ErrorMessage = false

			// проверка полей
			if (this.email === null || this.email === undefined || String(this.email).trim() === '' ||
				this.password === null || this.password === undefined || String(this.password).trim() === '')
			{
				this.form_ErrorMessage = this.localeFtc('login/incorrect')
				return
			}

			// готовим объект запроса и url запроса
			let _obj = {
				email: this.email,
				password: this.password
			}
			let _url = '/login'

			// если это клиент - добавим флаг запоминания
			if (!this.is_admin) _obj['rememberMe'] = this.rememberMe

			// запрос на аутентификацию
			this.forms_GetThenPost(_url, _obj,
				// успех
				(data) => {
					// если пришли корректные данные
					if (data &&
						'user' in data && data['user'] &&
						'_session' in data && data['_session'] &&
						'user_id' in data['user'] && 'user_email' in data['user'] && 'user_avatar_path' in data['user'] &&
						window.localStorage && window.sessionStorage)
					{
						// тип пользователя
						let _type = this.is_admin ? 'admin' : 'client'
						// если он явно указан
						if ('user_type' in data && data['user_type'] && (data['user_type'] === 'admin' || data['user_type'] === 'user'))
							_type = data['user_type'] === 'admin' ? 'admin' : 'client'

						// сохраним в localStorage тип - на данном этапе этого достаточно
						window.localStorage.setItem('user_type', _type)

						// готовим url
						let _url = '/'
						// если есть уже запомненный путь
						if (this.$store.state.returnURL)
						{
							// сохраним его в sessionStorage
							// так как дальше будет редирект с полным релоадом
							// и хранилище Vuex будет обнулено
							window.sessionStorage.setItem('_ru', this.$store.state.returnURL)

							_url = this.$store.state.returnURL
							this.$store.commit('setReturnURL', false)
						}

						// "тяжелый" переход - c загрузкой всего приложения
						// иначе в FF начинает все время спрашивать "сохранить пароль?"
						window.location.href = _url
						window.location.reload(true)

						// на это все
						return
					}

					// по умолчанию - это fail
					this.failRequest()
				},
				// неудача - это fail
				(res) => {
					// если это 403 Blacklisted
					if (res && res.status === 403 && res.data && res.data.content === 'Blacklisted')
					{
						// ставим текст сообщения
						this.form_ErrorMessage = this.localeFtc('login/blacklisted')
						// аутентификации может и не быть, но подстрахуемся
						this.$store.commit('dropAuth')
					}
					// если это 511 Need 2FA Verify
					else if (res && res.status === 511 && res.data && res.data.content === 'Need 2FA Verify')
					{
						this.form_ErrorMessage = false
						// запрос формы
						this.$http.get(Vue.APIServerUrl + '/twofa/check')
						.then(res => {
							// получаем ответ
							let _dt = res && res.data && typeof res.data === 'object' ? res.data : false
							// если ответ корректный
							if (_dt && _dt['_csrf'] && _dt['model'] && _dt['status'] === 'form')
							{
								this.fields2FA = this.parseFormData(_dt)
								// просто показываем диалог
								this.show2FADialog()
								return
							}

							throw res
						})
						.catch(err => {
							let _msg = 'register/error'
							if (err) _msg = this.formatRequestError(err)
							this.form_ErrorMessage = _msg
						})

						return
					}
					// иная ошибка
					else this.failRequest()
				}
			)
		},

		//---------------------------------------------------------------------
		// диалог 2FA
		//---------------------------------------------------------------------
		onFocus2FA(field) {
			if (field) field['_errMsg'] = ''
		},
		hide2FADialogModal() {
			this.isInputDisabled = false
			this.$nextTick(() => {
				EventBus.$emit('w5-body-scroll-enable')
				this.show2FADialogModal = false
				this.hideModalMask()
			})
		},
		// показываем диалог по событию
		show2FADialog() {
			this.isInputDisabled = true
			this.$nextTick(() => {
				EventBus.$emit('w5-body-scroll-disable')
				this.show2FADialogModal = true
				this.$nextTick(() => {
					let _block = null
					if (this.$refs && this.$refs.code)
					{
						if (this.$refs.code.length)
							_block = this.$refs.code[0]
						else
							_block = this.$refs.code
					}

					if (_block && _block.$el)
					{
						let _input = _block.$el.querySelector('input')
						if (_input && _input.focus)
						{
							try { _input.focus() }
							catch (e) {}
						}
					}
				})
			})
		},
		// есть ли видимые поля в строке
		isVisibleField(row) {
			// по умолчанию не видна
			let _answer = false
			// ищем любое поле с типом не "hidden"
			row.some((item, idx, arr) => {
				// если такое поле есть - значит строка должна быть видима
				if (item && item.type !== 'hidden' && item['_visible'] === true)
				{
					_answer = true
					return true
				}
			})

			// возвращаем результат
			return _answer
		},
		// поиск полей формы 2FA
		find2FAField(name) {
			// бежим по всем полям
			let _rows = this.fields2FA.fields
			if (!_rows || !Array.isArray(_rows)) return null

			// поля есть - пробежимся по ним
			let _field = null
			_rows.some(item => {
				if (item && Array.isArray(item))
				{
					item.some(obj => {
						if (obj && obj['_field_name'] === name)
						{
							_field = obj
							return true
						}
					})

					if (_field) return true
				}
			})

			return _field
		},
		// сабмит формы 2FA
		submit2FAForm() {
			// проверим поле с кодом
			let _field = this.find2FAField('code')
			if (!_field) return
			if (!_field.value)
			{
				_field['_errMsg'] = 'error/required_field'
				return
			}

			// обнулим сообщения
			this.form_ErrorMessage = false

			// проверим - есть ли поля с ошибками
			let _isErr = this.fields2FA.fields.some(row => {
				let _found = false
				if (row && Array.isArray(row) && row.length)
				{
					_found = row.some(fld => {
						if (!fld['_visible']) return false
						// обязательное поле?
						if (fld['required'] === true)
						{
							// если значение вообще не задано
							if (fld.value === undefined || fld.value === null)
							{
								fld['_errMsg'] = 'error/required_field'
								return true
							}
						}
					})
				}

				if (_found) return true
			})
			if (_isErr) return

			// все в порядке - делаем запрос
			// формируем URL
			let _url = this.APIServerUrl + '/twofa/check'
			// начинаем двойной запрос
			this.$http.get(_url).then(
				// положительный ответ
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// если ответ корректный
					if (_dt && _dt['_csrf'] && _dt['model'] && _dt['status'] === 'form')
					{
						// формируем POST-параметры
						let _post = { '_csrf': _dt['_csrf'] }
						_post[_dt['model']] = {}
						// соберем значения всех полей
						this.fields2FA.fields.forEach(row => {
							if (row && Array.isArray(row) && row.length)
							{
								row.forEach(fld => {
									let _value = fld['value']
									if (fld['type'] === 'boolean')
									{
										_value = Helper.normalizeBooleanValue(fld['value']) ? 1 : 0
									}
									_post[_dt['model']][fld['_field_name']] = _value
								})
							}
						})
						// производим запрос POST
						this.$http.post(_url, Helper.toFormData(_post)).then(
							// успешный ответ сервера
							resPost => {
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok')
								{
									// успешно - входим заново
									this.login()
									// на этом все
									return
								}

								// если указана какая то ошибка
								if (_dt && _dt['status'] === 'error' && _dt['fields'] && typeof _dt['fields'] === 'object')
								{
									// бежим по всем полям
									for (let f in _dt['fields']) if (_dt['fields'].hasOwnProperty(f))
									{
										// сразу ищме поле
										let _fld = this.find2FAField(f)
										if (_fld)
										{
											// сообщение по умолчанию
											_fld['_errMsg'] = this.localeFtc('main/error_desc').replace(':', '')
											// если пришел массив - берем первое сообщение
											if (Array.isArray(_dt['fields'][f]))
											{
												if (_dt['fields'][f].length)
													_fld['_errMsg'] = this.localeFtc(_dt['fields'][f][0])
											}
											else _fld['_errMsg'] = this.localeFtc(_dt['fields'][f])
										}
									}

									return
								}

								// закроме диалог
								this.hide2FADialogModal()
								// иная ошибка
								this.form_ErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								// закроме диалог
								this.hide2FADialogModal()
								// ошибка сервера
								this.form_ErrorMessage = this.formatRequestError(resPost)
							}
						)

						// на этом все
						return
					}

					// закроме диалог
					this.hide2FADialogModal()
					// ошибка формата ответа
					this.form_ErrorMessage = this.formatRequestError(resGet)
				},
				// отрицательный ответ
				resGet => {
					// закроме диалог
					this.hide2FADialogModal()
					// ошибка сервера
					this.form_ErrorMessage = this.formatRequestError(resGet)
				}
			)
		}

		//---------------------------------------------------------------------
	},

	//=========================================================================
	components: {
		Field
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>



// WEBPACK FOOTER //
// Login.vue?70c5d25e